import api from '@/services/api'
import FilterActions from './actions-types'
import UserRoles from '@/store/core/user/user-roles'
import i18n from '@/i18n.js'

export default {
  [FilterActions.GET_ALL_FILTERS]({}, options) {
    return new Promise((resolve, reject) => {
      api.node.filter
        .getFilters(options)
        .then((response) => {
          resolve(response.data)
        })
        .catch(() => reject())
    })
  },

  [FilterActions.GET_FILTER_FULL]({}, filterId) {
    return new Promise((resolve, reject) => {
      api.node.filter
        .getFilterFull(filterId)
        .then((response) => {
          resolve(response.data)
        })
        .catch(() => reject())
    })
  },

  [FilterActions.SAVE_FILTER]({ state, rootGetters }) {
    return new Promise((resolve, reject) => {
      let data = {}
      state.fields.forEach((item) => {
        data[item.name] = item.value
      })

      const isMaster = rootGetters['core/auth/checkAccessRights']([UserRoles.USER_MASTER])
      if (!isMaster && !data.tenant_id) {
        return reject(new Error(i18n.t('filter_tenant_required')))
      }

      api.node.filter
        .createFilter(data)
        .then((response) => {
          resolve(response.body)
        })
        .catch((error) => {
          reject(error.response ? error.response.data : error)
        })
    })
  },

  [FilterActions.SAVE_FILTER_FULL]({}, {filterId, params}) {
    return new Promise((resolve, reject) => {
      api.node.filter
        .saveFilterFull(filterId, params)
        .then((response) => {
          resolve(response.body)
        })
        .catch((error) => {
          reject(error.response.data)
        })
    })
  },
}
